import { createClient, FindOperation, getRequestFactory, SearchOperation, searchRequestFactory } from '@infuse/api/common';
import { LogMessageSearchOptions, Message } from './model';

const client = createClient('/api/messages');

export const messagePermissions = {
  SEARCH: 'econnector.search-log-messages',
  GET: 'econnector.get-log-message'
};

export const searchMessages: SearchOperation<Message, LogMessageSearchOptions> = searchRequestFactory<Message>(client, {
  permissionId: messagePermissions.SEARCH
});
export const getMessage: FindOperation<Message, string> = getRequestFactory<Message, string>(client, {
  permissionId: messagePermissions.GET
});
